namespace Solovis.UI {

    export interface PopupLinkPanelLink {
        label?: string;
        href?: string;
        target?: string;
        dataTestId?: string;
        click?: () => void;

        header?: string,
        separator?: boolean;

        // Only supported when useLegacyPanel is not set to true -- forwarded to the underlying
        // dxContextMenu item's native `disabled` option (see DevExtreme's dxMenuBaseItem), the
        // same mechanism used to disable other DevExtreme widgets throughout the app.
        disabled?: boolean;

        // links sub-menu is only supported when useLegacyPanel is not set to true.
        links?: PopupLinkPanelLink[];
    }

    export interface PopupLinkPanelOptions {
        newUIEnabled?: boolean;
        noPaddingAtTop?: boolean;
        calledFromShowLinks?: boolean;
        autoClickSingleItem?: boolean;
        links?: PopupLinkPanelLink[];
        close?: () => void;

        closeOnMouseDown?: boolean;
        closeOnEscape?: boolean;

        offset?: {
            pageX?: any;
            pageY?: any;
            left?: any;
            top?: any;
        };
        useDefaultPositionBoundary?: boolean,
        useDefaultPositionOf?: boolean,

        offsetElement?: string | JQuery | HTMLElement;

        offsetRight?: boolean;
        offsetBottom?: boolean;
        zIndex?: number;

        fromRightEdge?: boolean;
        fromBottomEdge?: boolean;

        /**
         * If set to true, the legacy panel renderer will be used. Otherwise, dxContextMenu will be used for
         * rendering the context menu.
         */
        useLegacyPanel?: boolean;
    }

    /**
     * PopupLinkPanel should always be created using static showLinks method.
     */
    export class PopupLinkPanel {

        public _linkPanelDiv: any;
        public _cleanupMethod: any;
        public _noPaddingAtTop: any;

        constructor(options: PopupLinkPanelOptions) {
            if (!options.calledFromShowLinks) {
                throw "PopupLinkPanel should always be created using static showLinks method.";
            }

            this._linkPanelDiv = null;
            this._cleanupMethod = null;

            this._noPaddingAtTop = Solovis.isNotNull(options.noPaddingAtTop) ? options.noPaddingAtTop : false;
        }


        public replaceLinks(links) {
            var self = this;
            var linkPanelDiv = this._linkPanelDiv;

            if (linkPanelDiv === null) {
                // Panel has been destroyed.
                return;
            }

            linkPanelDiv.html("");
            if (this._noPaddingAtTop) {
                linkPanelDiv.css("padding-top", "0");
            }

            var linkListDiv = $("<div>").addClass("popup-link-list").appendTo(linkPanelDiv);

            $(links).each(function (i, link: any) {
                if (link.html) {
                    var htmlDiv = $("<div>").html(link.html);
                    htmlDiv.appendTo(linkListDiv);
                }
                else if (link.separator) {
                    var separatorDiv = $("<div>").addClass("horizontal-separator");
                    separatorDiv.appendTo(linkListDiv);
                }
                else if (link.header) {
                    var headerDiv = $("<div>").text(link.header)
                        .css("padding", "5px")
                        .css("width", "100%")
                        .css("font-size", "120%")
                        .css("color", "#fff")
                        .css("background-color", "#aaa");

                    headerDiv.appendTo(linkListDiv);
                }
                else {
                    var linkDiv = $("<div>").appendTo(linkListDiv);

                    var linkElement = $("<a>").text(link.label);

                    
                    if (link.href) {
                        linkElement.attr("href", Solovis.resolveUrl(link.href));
                    }
                    if (link.target) {
                        linkElement.attr("target", link.target);
                    }

                    if (link.dataTestId) {
                        linkElement.attr("data-testid", link.dataTestId);
                    }

                    if (link.click) {
                        linkElement.click(link.click);
                    }
                    
                    linkElement.click(function () {
                        // Remove panel after linked clicked.
                        self.destroy();
                    });

                    linkElement.appendTo(linkDiv);
                }
            });
        };

        public destroy() {
            this._cleanupMethod();
            this._linkPanelDiv = null;
        }

        /**
         * This will attempt to make sure the popup link panel is visible in the viewport.
         */
        public moveToViewport() {
            if (!this._linkPanelDiv)
                return;

            var windowWidth = $(window).width();
            var windowHeight = $(window).height();
            var windowLeft = $(window).scrollLeft();
            var windowTop = $(window).scrollTop();
            var windowBottom = windowTop + windowHeight;
            var windowRight = windowLeft + windowWidth;

            var panelOffset = $(this._linkPanelDiv).offset();
            var panelWidth = $(this._linkPanelDiv).outerWidth();
            var panelHeight = $(this._linkPanelDiv).outerHeight();

            if ((panelOffset.top + panelHeight) > windowBottom) {
                // Move the panel up, but not so far that top is off top of screen.
                var newTop = windowBottom - panelHeight;
                if (newTop < windowTop) {
                    newTop = windowTop;
                }

                $(this._linkPanelDiv).css("top", "" + newTop + "px");
            }

            if ((panelOffset.left + panelWidth) > windowRight) {
                // Move the panel left, but not so far that left is off left of screen.
                var newLeft = windowRight - panelWidth;
                if (newLeft < windowLeft) {
                    newLeft = windowLeft;
                }

                $(this._linkPanelDiv).css("left", "" + newLeft + "px");
            }
        };


        /**
         * Add a handler for when user clicks element or activates contextmenu.
         * @param element
         * @param clickCallback
         */
        public static onElementClick(element, clickCallback) {
            var handler = function (e) {
                e.preventDefault();
                e.cancelBubble = true;
                clickCallback(e);
                return false;
            };

            if (element instanceof jQuery) {
                (element as JQuery).bind("click contextmenu", handler);
            }
            else {
                element.addEventListener("click", handler, false);
                element.addEventListener("contextmenu", handler, false);
            }
        };


        /**
         * Show a set of links in a popup panel and return instance to PopupLinkPanel object.
         * options:
         *  links: array of { label/href/click }
         *  noPaddingAtTop: true/false (default: false; set to true to remove padding at top of panel)
         */
        public static showLinks(options: PopupLinkPanelOptions) {
            if (!options.useLegacyPanel) {
                return PopupLinkPanel._showLinksWithDxContextMenu(options);
            }

            var noPaddingAtTop = Solovis.isNotNull(options.noPaddingAtTop) ? options.noPaddingAtTop : false;

            var popupLinkPanel = new PopupLinkPanel({ calledFromShowLinks: true, noPaddingAtTop: noPaddingAtTop });

            var links = options.links;
            var closeCallback = options.close ? options.close : null;
            var self = this;
            var linkPanelDiv = null;

            if (options.autoClickSingleItem && links) {
                if (links.length == 1) {
                    var linkToAutoClick = links[0];
                    if (linkToAutoClick.href) {
                        (window as any).location = linkToAutoClick.href;
                        return;
                    }
                    else if (typeof linkToAutoClick.click == "function") {
                        linkToAutoClick.click();
                        return;
                    }
                }
            }

            var removePanelInterface = function () {
                if (linkPanelDiv) {
                    linkPanelDiv.remove();
                    linkPanelDiv = null;

                    if (closeCallback) {
                        closeCallback();
                    }
                }
            };

            var hidePanelOnMouseDown = null;
            var hidePanelOnEscape = null;
            var cleanupPanel = function () {
                removePanelInterface();
                if (hidePanelOnMouseDown) {
                    $(window).unbind("mousedown", hidePanelOnMouseDown);
                }
                if (hidePanelOnEscape) {
                    $(document.body).unbind("keydown", hidePanelOnEscape);
                }
            };

            if (!Solovis.isNotNull(options.closeOnMouseDown) || options.closeOnMouseDown) {
                hidePanelOnMouseDown = function (event) {
                    // Hide interface if click is not on our div.
                    var current = event.target;

                    if (!linkPanelDiv) {
                        popupLinkPanel.destroy();
                    }
                    else {
                        var isChild = false;
                        while (current) {
                            if (current == linkPanelDiv.get(0)) {
                                isChild = true;
                                break;
                            }
                            current = current.parentNode;
                        }

                        if (!isChild) {
                            popupLinkPanel.destroy();
                        }
                    }
                };

                $(window).bind("mousedown", hidePanelOnMouseDown);
            }

            if (!Solovis.isNotNull(options.closeOnEscape) || options.closeOnEscape) {
                hidePanelOnEscape = function (event) {
                    if (event.keyCode === ($ as any).ui.keyCode.ESCAPE) {
                        popupLinkPanel.destroy();
                    }
                    event.stopPropagation();
                };

                $(document.body).bind("keydown", hidePanelOnEscape);
            }

            linkPanelDiv = $("<div>");

            popupLinkPanel._linkPanelDiv = linkPanelDiv;
            popupLinkPanel._cleanupMethod = cleanupPanel;

            popupLinkPanel.replaceLinks(links);

            // Determine appropriate position of the popup link panel.

            var linkPanelOffset: any = {};
            if (options.offset) {
                if (typeof options.offset.pageX == "number") {
                    // Allow click event to be used to specify offset.
                    linkPanelOffset = { left: options.offset.pageX, top: options.offset.pageY };
                }
                else {
                    linkPanelOffset = options.offset;
                }
            }
            else if (options.offsetElement) {
                linkPanelOffset = $(options.offsetElement).offset();

                if (options.offsetRight) {
                    linkPanelOffset.left += $(options.offsetElement).outerWidth();
                }
                if (options.offsetBottom) {
                    linkPanelOffset.top += $(options.offsetElement).outerHeight();
                }
            }

            var zIndexOption = null;
            if (Solovis.isNotNull(options.zIndex)) {
                zIndexOption = options.zIndex;
            }
            else {
                var maxBodyZIndex = Solovis.UI.DomHelper.findMaxZIndexForElementChildren(document.body);
                zIndexOption = Math.max(maxBodyZIndex + 1, 1000);
            }

            linkPanelDiv
                .addClass("popup-panel")
                .addClass("popup-link-panel");

            if (options.fromRightEdge) {
                var windowWidth = $(window).width();
                linkPanelOffset.right = windowWidth - linkPanelOffset.left;
                delete linkPanelOffset.left;
            }

            if (options.fromBottomEdge) {
                var windowHeight = $(window).height();
                linkPanelOffset.bottom = windowHeight - linkPanelOffset.top;
                delete linkPanelOffset.top;
            }

            if (Solovis.isNotNull(linkPanelOffset.left)) {
                linkPanelDiv.css("left", "" + linkPanelOffset.left + "px");
            }

            if (Solovis.isNotNull(linkPanelOffset.top)) {
                linkPanelDiv.css("top", "" + linkPanelOffset.top + "px");
            }

            if (Solovis.isNotNull(linkPanelOffset.right)) {
                linkPanelDiv.css("right", "" + linkPanelOffset.right + "px");
            }

            if (Solovis.isNotNull(linkPanelOffset.bottom)) {
                linkPanelDiv.css("bottom", "" + linkPanelOffset.bottom + "px");
            }

            if (Solovis.isNotNull(zIndexOption)) {
                linkPanelDiv.css("z-index", zIndexOption);
            }

            linkPanelDiv.appendTo(document.body);

            popupLinkPanel.moveToViewport();

            return popupLinkPanel;
        }


        private static _showLinksWithDxContextMenu(options: PopupLinkPanelOptions) {

            let links = options.links;
            let closeCallback = options.close ? options.close : null;

            let result = null;

            let createItemForLink = function (link) {
                let item: any = {};

                if (link.label) {
                    item.text = link.label;
                }
                else if (link.header) {
                    item.text = link.header;
                    item.header = true;
                }

                // Native dxContextMenu item option -- DevExtreme itself renders the disabled
                // state and blocks the click, same as elsewhere in the app (e.g. dxCheckBox,
                // dxTextBox); no custom styling or click-guard needed here.
                if (link.disabled) {
                    item.disabled = true;
                }

                if (link.target) {
                    item.target = link.target;
                }

                if (link.dataTestId) {
                    item.dataTestId = link.dataTestId;
                }

                
                if (link.href) {
                    item.href = Solovis.resolveUrl(link.href);
                    if (!link.click) {
                        item.onClick = function (e) {
                            let itemData = e.itemData;
                            if (itemData.href) {
                                if (itemData.target) {
                                    (window as any).open(itemData.href, itemData.target);
                                }
                                else {
                                    (window as any).location = itemData.href;
                                }
                            }
                        }
                    }
                }

                if (link.click) {
                    item.onClick = function () {
                        link.click();

                        if (result && result.dxContextMenuInstance) {
                            result.dxContextMenuInstance.hide();
                        }
                    };
                }

                if (link.links && link.links.length > 0) {
                    item.items = getItemsForLinks(link.links);
                }

                return item;
            };

            let getItemsForLinks = function (links) {
                let lastLinkWasSeparator = false;

                let items = [];
                for (let link of links) {
                    if (link.separator) {
                        lastLinkWasSeparator = true;
                    }
                    else {
                        let item = createItemForLink(link);

                        if (lastLinkWasSeparator) {
                            item.beginGroup = true;
                        }

                        items.push(item);

                        lastLinkWasSeparator = false;
                    }
                }

                return items;
            }

            let contextItems = getItemsForLinks(links);

            var zIndexOption = null;
            if (Solovis.isNotNull(options.zIndex)) {
                zIndexOption = options.zIndex;
            }
            else {
                var maxBodyZIndex = Solovis.UI.DomHelper.findMaxZIndexForElementChildren(document.body);
                zIndexOption = Math.max(maxBodyZIndex + 1, 1000);
            }

            let menuDiv = $("<div>").appendTo(document.body);
            $(menuDiv).dxContextMenu({
                items: contextItems,
                itemTemplate: (itemData, itemIndex, itemElement) => {
                    const newUITextClass = "slvs-h6 !tw-text-subtle";

                    if (itemData.href) {
                        if(options.newUIEnabled) (itemElement.addClass("paux"));
                        const itemSpan = $("<div>")
                            .addClass(`${options.newUIEnabled ? newUITextClass : ''} dx-menu-item-text`)
                            .css("padding", 0)
                            .css("display", "block")
                            .appendTo(itemElement);
                        if (itemData.dataTestId) {
                            itemSpan.attr("data-testid", itemData.dataTestId);
                        }
                        $("<i class='fa fa-external-link'>")
                            .attr("title", "Open In New Tab")
                            .css("padding-top", "4px")
                            .css("line-height", "17px")
                            .css("float", "right")
                            .css("cursor", "pointer")
                            .css("display", "inline-block")
                            .click((e) => {
                                e.preventDefault();
                                e.cancelBubble = true;
                                window.open(itemData.href, "_blank");
                                $(menuDiv).dxContextMenu("hide");
                                return false;
                            })
                            .appendTo(itemSpan);
                        
                        const link = $("<div>")
                            .text(itemData.text)
                            .css("margin-right", "30px")
                            .css("display", "inline-block")
                            .appendTo(itemSpan);
                    }
                    else {
                        if(options.newUIEnabled) (itemElement.addClass("paux"));
                        const itemSpan = $("<span>").addClass(`${options.newUIEnabled ? newUITextClass : ''} dx-menu-item-text`).appendTo(itemElement);
                        itemSpan.text(itemData.text);
                        if (itemData.dataTestId) {
                            itemSpan.attr("data-testid", itemData.dataTestId);
                        }
                        if (itemData.header) {
                            itemSpan.css("font-weight", "bold");
                            itemSpan.css("color", "#fff");

                            $(itemElement).click(function (e) {
                                e.preventDefault();
                                e.cancelBubble = true;
                                return false;
                            });
                            itemElement.css("cursor", "auto");

                            $($(itemElement).closest(".dx-menu-item")).css("background-color", "#333").addClass(`${options.newUIEnabled ? "tw-text-white tw-font-bold" : ''}`);
                            $($(itemElement).closest(".dx-menu-item")).find("span").removeClass("!tw-text-subtle");
                        }
                    }
                    if (itemData.items && itemData.items.length > 0) {
                        $('<span class="dx-menu-item-popout-container"><div class="dx-menu-item-popout"></div></span>').appendTo(itemElement);
                    }
                },
                onPositioning: function (ePos) {
                    if (options.useDefaultPositionBoundary === false) {
                        ePos.position.boundary = $(document.body);
                    }

                    if (options.offset) {
                        if (options.useDefaultPositionOf === false) {
                            ePos.position.of = $(window);
                        }

                        let linkPanelOffset = null;
                        if (typeof options.offset.pageX == "number") {
                            // Allow click event to be used to specify offset.
                            linkPanelOffset = { left: options.offset.pageX, top: options.offset.pageY };
                        }
                        else {
                            linkPanelOffset = options.offset;
                        }

                        // -3 pixels is just to insure the bottom of the popup panel doesn't blend with the bottom of the browser window, making the illusing of more info being there
                        ePos.position.offset = { x: linkPanelOffset.left, y: linkPanelOffset.top - 3};
                    }
                    else if (options.offsetElement) {
                        ePos.position.of = $(options.offsetElement);

                        ePos.position.my = { x: "left", y: "top" };
                        ePos.position.at = { x: "left", y: "top" };

                        if (options.offsetRight) {
                            ePos.position.my.x = "right";
                            ePos.position.at.x = "right";
                        }
                        if (options.offsetBottom) {
                            ePos.position.at.y = "bottom";
                        }
                    }

                    ePos.position.collision = "fit";
                },
                onHidden: () => {
                    $(menuDiv).dxContextMenu("dispose");
                    $(menuDiv).remove();

                    if (closeCallback) {
                        closeCallback();
                    }
                }
            });
            $(menuDiv).dxContextMenu("show");

            result = {
                isDxContextMenu: true,
                dxContextMenuInstance: $(menuDiv).dxContextMenu("instance"),

                destroy: function () {
                    this.dxContextMenuInstance.dispose();
                    $(menuDiv).remove();
                }
            };

            return result;
        }
    }

}




